var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBulkManage01 = function SvgBulkManage01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bulk_manage-01_svg2__a",
    x1: 5.15,
    x2: 137.05,
    y1: 151.22,
    y2: 19.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#bulk_manage-01_svg2__a",
    id: "bulk_manage-01_svg2__b",
    x1: -44.85,
    x2: 87.05,
    y1: 101.22,
    y2: -30.67
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#bulk_manage-01_svg2__a",
    id: "bulk_manage-01_svg2__c",
    x1: -16.75,
    x2: 115.14,
    y1: 129.32,
    y2: -2.58
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#bulk_manage-01_svg2__a",
    id: "bulk_manage-01_svg2__d",
    x1: 11.37,
    x2: 143.27,
    y1: 157.44,
    y2: 25.55
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#bulk_manage-01_svg2__a",
    id: "bulk_manage-01_svg2__e",
    x1: 36.4,
    x2: 168.29,
    y1: 182.47,
    y2: 50.57
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#bulk_manage-01_svg2__a",
    id: "bulk_manage-01_svg2__f",
    x1: 50.41,
    x2: 182.3,
    y1: 196.48,
    y2: 64.58
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M50.15 56.27h124.88c6.89 0 12.49-5.59 12.49-12.49s-5.59-12.49-12.49-12.49H50.15c-6.89 0-12.49 5.59-12.49 12.49s5.59 12.49 12.49 12.49",
    style: {
      fill: "url(#bulk_manage-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.8 35h.1C1.5 37.39.1 40.49.1 43.79v2.4c.1.8.4 1.6.7 2.4.3.7.7 1.5 1.2 2.1.4.7 1 1.4 1.6 1.9.6.6 1.2 1.1 1.9 1.5q1.05.75 2.1 1.2c.8.4 1.7.7 2.6.9h2.4c3.3 0 6.49-1.3 8.79-3.6.6-.6 1.1-1.2 1.6-1.9q.75-1.05 1.2-2.1.6-1.2.9-2.4v-2.4c0-3.3-1.3-6.49-3.7-8.79-4.9-4.8-12.69-4.8-17.58 0Z",
    style: {
      fill: "url(#bulk_manage-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.88 93.04h.1c-.4-.7-1-1.3-1.6-1.9-4.9-4.8-12.69-4.8-17.58 0-2.3 2.3-3.7 5.49-3.7 8.79 0 1.6.3 3.3.9 4.8.3.7.7 1.4 1.1 2.1.5.7 1 1.3 1.6 1.9s1.2 1.1 1.9 1.6q1.05.75 2.1 1.2c.8.3 1.6.6 2.4.7.8.2 1.6.3 2.4.2h2.4c.8-.1 1.6-.4 2.3-.7.8-.3 1.5-.7 2.2-1.2.7-.4 1.3-1 1.9-1.6s1.1-1.2 1.6-1.9q.75-1.05 1.2-2.1c.4-.8.7-1.7.9-2.6v-4.8c-.2-.8-.5-1.6-.9-2.3-.3-.8-.7-1.5-1.2-2.2Z",
    style: {
      fill: "url(#bulk_manage-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.88 149.28h.1c-.4-.7-1-1.3-1.6-1.9-4.9-4.8-12.69-4.8-17.58 0-.6.6-1.1 1.2-1.6 1.9q-.75 1.05-1.2 2.1c-.3.8-.6 1.6-.7 2.4q-.3 1.2-.3 2.4c0 3.3 1.3 6.49 3.7 8.79.6.6 1.2 1.1 1.9 1.6q1.05.75 2.1 1.2c.8.3 1.6.6 2.4.7.8.2 1.6.3 2.4.2h2.4c.8-.1 1.6-.4 2.3-.7.8-.3 1.5-.7 2.2-1.2.7-.4 1.3-1 1.9-1.6s1.1-1.2 1.6-1.9q.75-1.05 1.2-2.1c.4-.8.7-1.7.9-2.6v-4.8q-.3-1.2-.9-2.4c-.3-.7-.7-1.5-1.2-2.1Z",
    style: {
      fill: "url(#bulk_manage-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.51 87.54H50.15c-6.89 0-12.49 5.59-12.49 12.49s5.59 12.49 12.49 12.49h137.36c6.89 0 12.49-5.59 12.49-12.49s-5.59-12.49-12.49-12.49",
    style: {
      fill: "url(#bulk_manage-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.27 143.69H50.15c-6.89 0-12.49 5.59-12.49 12.49s5.59 12.49 12.49 12.49h81.12c6.89 0 12.49-5.59 12.49-12.49s-5.59-12.49-12.49-12.49",
    style: {
      fill: "url(#bulk_manage-01_svg2__f)"
    }
  }));
};
export default SvgBulkManage01;